import { autoinject } from "aurelia-framework";

/**
 * Represents the footer of a modal.
 */
@autoinject
export class ModalFooterCustomElement
{
}
